/**
 * Hub re-export of the monorepo-wide safe Zod resolver.
 *
 * Source of truth lives in `@wtc/ui` (`packages/ui/src/forms/safe-zod-resolver.ts`).
 * Kept here as a thin alias for backwards compatibility — existing hub imports of
 * `zodResolverCompat` / `zodResolver` from this path continue to work.
 *
 * Use `import { zodResolver } from "@west-tennessee-consulting/ui"` in new code.
 */
export {
  safeZodResolver as zodResolverCompat,
  safeZodResolver as zodResolver,
} from "@west-tennessee-consulting/ui";
